import React, { Component } from 'react'

class DefaultOverview extends Component {
  render() {
    const { overviewTotals } = this.props
    return (
      <div className="row infoBoxRow">
        <div
          className="infoBox"
          onClick={() => this.props.navToSection('Job Site Material Requests')}
        >
          <div className="infoBoxNumber">
            {overviewTotals && overviewTotals.total_material_requests}
          </div>
          <div className="infoBoxText">Material Requests</div>
        </div>
        <div className="infoBox" onClick={() => this.props.navToSection('Job Site Work Orders')}>
          <div className="infoBoxNumber">{overviewTotals && overviewTotals.total_work_orders}</div>
          <div className="infoBoxText">Work Orders</div>
        </div>
        <div
          className="infoBox"
          onClick={() => this.props.navToSection('Job Site Driver Requests')}
        >
          <div className="infoBoxNumber">
            {overviewTotals && overviewTotals.total_driver_requests}
          </div>
          <div className="infoBoxText">Driver Requests</div>
        </div>
        <div className="infoBox" onClick={() => this.props.navToSection('Job Site Change Orders')}>
          <div className="infoBoxNumber">
            {overviewTotals && overviewTotals.total_change_orders}
          </div>
          <div className="infoBoxText">Change Orders</div>
        </div>
        <div className="infoBox" onClick={() => this.props.navToSection('Job Site RFIs')}>
          <div className="infoBoxNumber">{overviewTotals && overviewTotals.total_rfis}</div>
          <div className="infoBoxText">RFIs</div>
        </div>
      </div>
    )
  }
}

export default DefaultOverview



// WEBPACK FOOTER //
// ./src/components/jobs/overview/DefaultOverview.js